<ng-container *ngIf="userId && channel">
  <vc-chat-header
    class="discussion__top"
    [channel]="channel"
    [userId]="userId"
    [product]="product$ | async"
    [shippingInformation]="shippingInformation$ | async"
    [negotiation]="negotiation$ | async"
    [receiverInfo]="receiver$ | async"
    [isSeller]="isSeller"
    [senderIsBlocked]="senderIsBlocked"
    [receiverIsBlocked]="receiverIsBlocked"
    (blockReceiver)="receiverIsBlocked = $event"
    (activeReportTracking)="trackingChat('report')"
    [isReserved]="isReserved"
    [reservation]="reservation"
    [email]="email"
  ></vc-chat-header>
  <vc-chat-content
    class="discussion__center"
    [channel]="channel"
    [userId]="userId"
    [receiverInfo]="receiver$ | async"
    [isSeller]="isSeller"
    [senderIsBlocked]="senderIsBlocked"
    [receiverIsBlocked]="receiverIsBlocked"
    [senderIsBanned]="senderIsBanned"
    [receiverIsBanned]="receiverIsBanned"
    (senderHasBeenBlocked)="senderIsBlocked = $event"
    [isReserved]="isReserved"
    [reservation]="reservation"
  ></vc-chat-content>
  <vc-chat-form
    class="discussion__bottom"
    [channel]="channel"
    [isReserved]="isReserved"
    [reservation]="reservation"
    [senderIsBlocked]="senderIsBlocked"
    [receiverIsBlocked]="receiverIsBlocked"
    [senderIsBanned]="senderIsBanned"
    [receiverIsBanned]="receiverIsBanned"
    [receiverInfo]="receiver$ | async"
    (sendMsgTracking)="trackingChat('message_sent')"
  ></vc-chat-form>
</ng-container>
